export const getColors = () => ({
  divider: 'rgba(0,0,0,.12)',
  scrollbarBackground: 'rgba(249, 249, 249, 1)'
});
